import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Accordion, AccordionItem, Button, convertGhostHTMLToReactComponents, IconExternalLink, TextField, Typography } from '@riac/design-system';
import { IconSearch } from '@riac/design-system';
import { IProps, IFaq } from 'src/pages/FAQPage/components/FaqItems/FaqItems.i';

export const FaqItems = ({ data, isLoading }: IProps) => {
  const [categories, setCategories] = useState<string[]>(getCategories(data));
  const [search, setSearch] = useState('');
  const [filtered, setFiltered] = useState<IFaq[]>(data);

  const handleSearch = () => {
    const searched = data.filter((item) => (
      // Compare against questions
      item.FaqItem.toLowerCase().includes(search.toLowerCase())
      // Compare against answers
      || item.FAQText.toLowerCase().includes(search.toLowerCase())
    ));
    // Updated filtered array based on search
    setFiltered(searched);
    // Update the categories to be shown based on search
    if(searched.length > 0) {
      setCategories(getCategories(searched));
    } else {
      setCategories([]);
    }
  };

  const clearSearch = () => {
    setSearch('');
    setFiltered(data);
  };

  useEffect(() => {
    if(!search) setCategories(getCategories(data));
    handleSearch();
  }, [search]);

  useEffect(() => {
    setCategories(getCategories(data));
    setFiltered(data);
  }, [data]);

  return (
    <div className='self-center gap-10 flex flex-col'>
      <TextField
        value={search}
        onChange={(e) => setSearch(e)}
        onReset={() => setSearch('')}
        placeholder='Search FAQs'
        icon={<IconSearch/>}
        hasReset
        isDisabled={isLoading}
      />
      <div className='flex flex-col gap-8'>
        <Accordion showOne>
          {categories.map((category, key) => (
            <div key={key} className='flex gap-3 flex-col'>
              <Typography tag='h2' heading weight='bold'>{category}</Typography>
              <ul className='flex flex-col gap-1'>
                {filtered.map((item, i) => (
                  category === item.CatagoryCaption && 
                    <AccordionItem heading={item.FaqItem} key={i} buttonClassName='text-[18px] leading-[22px] font-semibold py-1.5' className='border-b border-gray-200'>
                      <Typography size='sm' className='py-5 relative'>
                        <Button className='absolute top-1 right-1 text-text-lighter p-0.5' unstyled to={`/faq/${item.FAQSlug}`} aria-label='View FAQ'>
                          <IconExternalLink className='size-5'/>
                        </Button>
                        <div className='prose max-w-full'>
                          {convertGhostHTMLToReactComponents(item.FAQText)}
                        </div>
                      </Typography>
                    </AccordionItem>
                ))}
              </ul>
            </div>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export const getCategories = (list=[]) => {
  // Create empty array to hold collection of categories
  const cats = [];
  // Add first item in list to categories since none exist
  if(list.length > 0) cats.push(list[0]?.CatagoryCaption);
  // Loop through every item
  for(let i=1; i < list.length; i++) {
    // See if the current item's category is already in cats
    const exists = cats.includes(list[i].CatagoryCaption);
    // If it doesn't exist yet, add it to the cats array
    if(!exists) cats.push(list[i].CatagoryCaption);
  }
  // Return all of the unique categories from the list
  return cats;
};
